import React, { useState, useEffect, useRef } from 'react';

/**
 * HOC that wraps TopBar to inject auth selectors and actions.
 * Polls the auth state so the TopBar re-renders when userRole becomes available
 * (after fetchCurrentUser completes).
 */
const TopBarWrapper = (Original, system) => {
  const Wrapper = (props) => {
    const { pagoAuth2Selectors, pagoAuth2Actions } = system;
    const [role, setRole] = useState(() => pagoAuth2Selectors?.selectUserRole?.() || null);
    const intervalRef = useRef(null);

    useEffect(() => {
      if (role) return;
      intervalRef.current = setInterval(() => {
        const currentRole = pagoAuth2Selectors?.selectUserRole?.();
        if (currentRole) {
          setRole(currentRole);
          clearInterval(intervalRef.current);
        }
      }, 200);

      return () => clearInterval(intervalRef.current);
    }, []);

    // Pass userRole and all auth-related props so TopBar re-renders when it changes
    return (
      <Original
        {...props}
        pagoAuth2Selectors={pagoAuth2Selectors}
        pagoAuth2Actions={pagoAuth2Actions}
        userRole={role}
      />
    );
  };

  return Wrapper;
};

export default TopBarWrapper;

